import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { EmployeeConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { EmployeeService } from './api/employee.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EmployeeApiModule {
    public static forRoot(configurationFactory: () => EmployeeConfiguration): ModuleWithProviders<EmployeeApiModule> {
        return {
            ngModule: EmployeeApiModule,
            providers: [ { provide: EmployeeConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EmployeeApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EmployeeApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
